import { SelectedFilters } from '@/components/FilterData/types';
import { api } from '@/services/api';
import { UUID } from '@/api/generatedApi';
import {
  normalizeSelectedFilters,
  normalizeSearchQuery,
  normalizePage,
  normalizePerPage,
} from '@/components/Search/utils';

export const ASSET_COMPOSITE_SEARCH_QUERY_KEY = 'assets.assetCompositeSearch';

export const queryKey = ({
  assetId,
  tenantId,
  searchQuery,
  selectedFilters,
  page,
  perPage,
}: {
  assetId: UUID;
  tenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  page?: string | number;
  perPage?: string | number;
}) => [
  ASSET_COMPOSITE_SEARCH_QUERY_KEY,
  {
    assetId,
    tenantId,
    searchQuery: normalizeSearchQuery(searchQuery),
    selectedFilters,
    page: normalizePage(page),
    perPage: normalizePerPage(perPage),
  },
];

export const queryFunction =
  ({
    assetId,
    tenantId,
    searchQuery,
    selectedFilters,
    page,
    perPage,
  }: {
    assetId: UUID;
    tenantId: UUID;
    searchQuery?: string;
    selectedFilters?: SelectedFilters;
    page?: string | number;
    perPage?: string | number;
  }) =>
  () =>
    api.assets.assetCompositeSearch(
      {
        tenantId,
        assetId,
        page: normalizePage(page),
        perPage: normalizePerPage(perPage),
      },
      {
        searchQuery: normalizeSearchQuery(searchQuery),
        filters: normalizeSelectedFilters(selectedFilters),
      }
    );
